import React from "react";

import { Pie } from "react-chartjs-2";
import { ArcElement } from "chart.js";
import { Chart } from "chart.js";

Chart.register(ArcElement);

const PieChart = (props) => {
  let chartData;
  let chartOptions;
  if (props && props.type == "skillSentiments") {
    chartOptions = {
      title: {
        display: true,
        text: "Sentiments across skills",
      },
      legend: {
        display: true,
        position: "bottom",
      },
    };

    chartData = {
      labels: ["Positive", "Negative", "Neutral"],
      datasets: [
        {
          data: props.data,
          backgroundColor: ["#02B2AF", "#2E96FF", "#B800D8"],
          hoverBackgroundColor: ["#02B2AF", "#2E96FF", "#B800D8"],
        },
      ],
    };
  } else if (props && props.type == "skillExecutionStatus") {
    chartOptions = {
      title: {
        display: true,
        text: "Skill by Status",
      },
      legend: {
        display: true,
        position: "bottom",
      },
    };

    chartData = {
      labels: props.data.skillExecutionStatuses,
      datasets: [
        {
          data: props.data.skillExecutionStatusCount,
          backgroundColor: props.data.skillStatusColor,
          hoverBackgroundColor: props.data.skillStatusColor,
        },
      ],
    };
  } else if (props && props.type == "querySentiments") {
    chartOptions = {
      title: {
        display: true,
        text: "Sentiments Across Queries",
      },
      legend: {
        display: true,
        position: "bottom",
      },
    };

    chartData = {
      labels: props.data.isthumbsUpLabels,
      datasets: [
        {
          data: props.data.isThumbsUpCount,
          backgroundColor: props.data.querySentimentColors,
          hoverBackgroundColor: props.data.querySentimentColors,
        },
      ],
    };
  }
  return (
    <div style={{ width: "300px", height: "300px", margin: "0 auto" }}>
      <Pie options={chartOptions} data={chartData} />
    </div>
  );
};

export default PieChart;
